/* eslint-disable */

const getSegmentIoKey = (rootState) =>
  rootState.config.service['yola-template-gallery']['segmentio']['write_key'];

export default getSegmentIoKey;
